import { Plus } from "lucide-react";

import { Button, type ButtonProps } from "../ui/button";

export const AddMenuElementButton = ({
  menuElement,
  size = "lg",
  variant = "default",
}: {
  menuElement: string;
} & Pick<ButtonProps, "size" | "variant">) => (
  <Button
    id="add-menu-element-button"
    onClick={() =>
      window.dispatchEvent(
        new CustomEvent("openCreateMenuElementModal", {
          detail: {
            element: menuElement,
          },
        })
      )
    }
    size={size}
    type="button"
    variant={variant}
  >
    <Plus />
    <span className="capitalize">Add {menuElement}s</span>
  </Button>
);
